<script lang="ts" setup>
import type { OfferImage } from '~/types/Catalog';

defineProps<{ alt: string }>();

const catalogStore = useCatalogStore();
const { selectedOffer } = storeToRefs(catalogStore);

const selectedSlideIndex = ref(0);
const isShowFullscreenGallery = ref(false);

const images = ref<OfferImage[]>(
  [...selectedOffer.value.offer_images, ...selectedOffer.value.product_images].sort(
    (a, b) => Number(b.is_main) - Number(a.is_main),
  ),
);
</script>

<template>
  <section v-if="selectedOffer">
    <ProductPageImageSlider
      v-model:selected-slide-index="selectedSlideIndex"
      :alt
      :images
      :video="selectedOffer.carousel_video_link"
      @open-fullscreen="isShowFullscreenGallery = true"
    />

    <FullscreenImageGallery
      v-model:is-show="isShowFullscreenGallery"
      v-model:selected-slide-index="selectedSlideIndex"
      :alt
      :images
      :video="selectedOffer.carousel_video_link"
    />
  </section>
</template>
